export default __webpack_public_path__ + "static/media/spotify_logo.dffc4909.png";